import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import * as Sentry from '@sentry/angular';

Sentry.init({
  dsn: 'https://7f3d19aecfb598b80a9a71f3e48cca3c@o4508041493479424.ingest.de.sentry.io/4509349449433168',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: 'test',
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    Sentry.browserTracingIntegration(),
    // Registers the Replay integration,

    // disable masking
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false,      
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    'dev.mit.mpo.dk',
    'dev.my.musicnest.no',
    /^.*\.azurewebsites\.net$/, // Cover all Azure websites
    /^.*\.cloudapp\.azure\.com$/, // Cover Azure cloud services
    /^.*\.sentry\.io$/, // Ensure Sentry domains are included
  ],

  // Fix CORS issues with proper configuration
  allowUrls: [
    /https?:\/\/(.*\.)?mit\.mpo\.dk/,
    /https?:\/\/(.*\.)?my\.musicnest\.no/,
    /https?:\/\/(.*\.)?azurewebsites\.net/
  ],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // Add request headers for better CORS compatibility
  transportOptions: {
    headers: {
      'Origin': window.location.origin
    }
  }
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
